<div class="filter-group" data-group-visibility-id="showInfluenceFilters">
  <div class="filter-group-header">
    <div class="filter">
      <span class="input-group-btn">
        <button class="btn toggle-btn caret-btn" [class.off]="!filter.groupVisibility.showInfluenceFilters" (click)="filter.groupVisibility.showInfluenceFilters = !filter.groupVisibility.showInfluenceFilters; updateFilter()"></button>
      </span>
      <span class="filter-body">
        <span filter-title text="Influenced & Special Gear" [activeRules]="activeRules.influencedGearFiltersPoe1"></span>
      </span>
    </div>
  </div>

  @if (navigationEnabled || filter.groupVisibility.showInfluenceFilters) {
    <div class="filter-group-body" [class.collapsed]="!filter.groupVisibility.showInfluenceFilters">

        <div class="filter filter-property full-span" [class.disabled]="!filter.showInfluencedGear">
          <span class="input-group-btn">
            <button class="btn toggle-btn" [class.off]="!filter.showInfluencedGear"
              (click)="toggleShowInfluencedGear()"></button>
          </span>
          <span class="filter-body">
            <span filter-title text="Influenced Gear" [additionalContent]="influencedGearStylePreview" ruleId="gear-influenced">
              <ng-template #influencedGearStylePreview>
                <app-equipment-tier-picker
                  [equipmentType]="EquipmentType.OtherGearInfluenced"
                  [alignLeft]="true"
                  [active]="filter.showInfluencedGear"
                  exampleName="Example Gear"
                  [influence]="'Shaper'"
                  [rarity]="Rarity.Rare"></app-equipment-tier-picker>
              </ng-template>
            </span>
            <span class="sep"></span>
            <app-select-gear-tier [disabled]="!filter.showInfluencedGear" [(ngModel)]="filter.showInfluencedGearMinBaseTypeTier" (selectedValueChange)="updateFilter()"></app-select-gear-tier>
            <span class="sep"></span>
            <input type="number" placeholder="≥ iLvl" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax"
              [disabled]="!filter.showInfluencedGear"
              [(ngModel)]="filter.showInfluencedGearMinItemLevel" (change)="updateFilter()">
          </span>
        </div>

        <div class="filter filter-property full-span" [class.disabled]="!filter.showFracturedGear">
          <span class="input-group-btn">
            <button class="btn toggle-btn" [class.off]="!filter.showFracturedGear"
              (click)="toggleShowFracturedGear()"></button>
          </span>
          <span class="filter-body">
            <span filter-title text="Fractured Gear" [additionalContent]="fracturedGearStylePreview" ruleId="gear-fractured">
              <ng-template #fracturedGearStylePreview>
                <app-equipment-tier-picker
                  [equipmentType]="EquipmentType.OtherGearFractured"
                  [alignLeft]="true"
                  [active]="filter.showFracturedGear"
                  exampleName="Example Gear"
                  [fractured]="true"
                  [rarity]="Rarity.Rare"></app-equipment-tier-picker>
              </ng-template>
            </span>
            <span class="sep"></span>
            <app-select-gear-tier [disabled]="!filter.showFracturedGear" [(ngModel)]="filter.showFracturedGearMinBaseTypeTier" (selectedValueChange)="updateFilter()"></app-select-gear-tier>
            <span class="sep"></span>
            <input type="number" placeholder="≥ iLvl" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax"
              [disabled]="!filter.showFracturedGear"
              [(ngModel)]="filter.showFracturedGearMinItemLevel" (change)="updateFilter()">
          </span>
        </div>

        @if (!filter.ruthless) {
        <div class="filter filter-property full-span" [class.disabled]="!filter.showVeiledGear">
          <span class="input-group-btn">
            <button class="btn toggle-btn" [class.off]="!filter.showVeiledGear"
              (click)="toggleShowVeiledGear()"></button>
          </span>
          <span class="filter-body">
            <span filter-title text="Veiled Gear" [additionalContent]="veiledGearStylePreview" ruleId="gear-veiled">
              <ng-template #veiledGearStylePreview>
                <app-equipment-tier-picker
                  [equipmentType]="EquipmentType.OtherGearVeiled"
                  [alignLeft]="true"
                  [active]="filter.showVeiledGear"
                  exampleName="Example Gear"
                  [veiled]="true"
                  [rarity]="Rarity.Rare"></app-equipment-tier-picker>
              </ng-template>
            </span>
            <span class="sep"></span>
            <app-autocomplete style="width: 150px"
              [allLabel]="'All Veiled'"
              [options]="syndicateMembers"
              [disabled]="!filter.showVeiledGear"
              [showOptions]="true"
              [selectedValues]="filter.showVeiledGearOfSyndicateMembers || ['All Veiled']"
              (selectedValuesChange)="filter.showVeiledGearOfSyndicateMembers = $event; updateFilter()">
            </app-autocomplete>
            <span class="sep"></span>
            <app-select-gear-tier [disabled]="!filter.showVeiledGear" [(ngModel)]="filter.showVeiledGearMinBaseTypeTier" (selectedValueChange)="updateFilter()"></app-select-gear-tier>
            <span class="sep"></span>
            <input type="number" placeholder="≥ iLvl" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax"
              [disabled]="!filter.showVeiledGear"
              [(ngModel)]="filter.showVeiledGearMinItemLevel" (change)="updateFilter()">
          </span>
        </div>
        }

        <div class="filter filter-property full-span" [class.disabled]="!filter.showMemoryStrandGear">
          <span class="input-group-btn">
            <button class="btn toggle-btn" [class.off]="!filter.showMemoryStrandGear"
              (click)="toggleShowMemoryStrandGear()"></button>
          </span>
          <span class="filter-body">
            <span filter-title text="Memory Strand Gear" [additionalContent]="memoryStrandGearStylePreview" ruleId="gear-memory-strands">
              <ng-template #memoryStrandGearStylePreview>
                <app-equipment-tier-picker
                  [equipmentType]="EquipmentType.OtherGearMemoryStrands"
                  [alignLeft]="true"
                  [active]="filter.showMemoryStrandGear"
                  exampleName="Example Gear"
                  [memoryStrands]="true"
                  [rarity]="Rarity.Rare"></app-equipment-tier-picker>
              </ng-template>
            </span>
            <span class="sep"></span>
            <input type="number" placeholder="Min" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax"
              [disabled]="!filter.showMemoryStrandGear"
              [(ngModel)]="filter.showMemoryStrandGearMinStrands" (change)="updateFilter()">
            <span class="sep"></span>
            <app-select-gear-tier [disabled]="!filter.showMemoryStrandGear" [(ngModel)]="filter.showMemoryStrandGearMinBaseTypeTier" (selectedValueChange)="updateFilter()"></app-select-gear-tier>
            <span class="sep"></span>
            <input type="number" placeholder="≥ iLvl" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax"
              [disabled]="!filter.showMemoryStrandGear"
              [(ngModel)]="filter.showMemoryStrandGearMinItemLevel" (change)="updateFilter()">
          </span>
        </div>

    </div>
    <div class="clear"></div>
  }
</div>
